import validate from "/Users/klemen/Desktop/Development/kroznik/monorepo/kroznik_backoffice/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/Users/klemen/Desktop/Development/kroznik/monorepo/kroznik_backoffice/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/Users/klemen/Desktop/Development/kroznik/monorepo/kroznik_backoffice/middleware/auth.ts")
}